export const CONT_COLLECTIONS = {
  // Módulo de Gestión de Compras (Logística)
  PROVEEDORES: "oc_proveedores",
  COMPRAS: "oc_compras",
  CUENTAS_PAGAR: "oc_cuentas_pagar",
  PAGOS_PROVEEDORES: "oc_pagos_proveedores",
  ORDENES_COMPRA: "oc_ordenes_compra",
  ITEMS_CATALOGO: "oc_items_catalogo",

  // Módulo Comercial transversal (Compras / Ventas / Tesorería)
  DOCUMENTOS_COMERCIALES: "gco_documentos_comerciales",
  ORDENES_VENTA: "os_ordenes_venta",
  COMPROBANTES_VENTA: "os_comprobantes_venta",
  CORRELATIVOS: "gco_correlativos",


  // Módulo de Gestión Contable (PCGE y Libros)
  ASIENTOS: "gco_asientos",
  PLAN_CUENTAS: "gco_plan_cuentas",
  REGLAS_ASIENTO: "gco_reglas_asiento",
  // Módulo SIRE (Fase 15/21)
  SIRE_PERIODOS: "gco_sire_periodos",
  SIRE_PROPUESTAS_SUNAT: "gco_sire_propuestas_sunat",
  SIRE_CONCILIACIONES: "gco_sire_conciliaciones",
  SIRE_ARCHIVOS: "gco_sire_archivos",
  SIRE_PRESENTACIONES: "gco_sire_presentaciones",
  SIRE_CONFIG: "gco_sire_config",
  SIRE_AUTORIZACIONES: "gco_sire_autorizaciones",
  SIRE_INTENTOS: "gco_sire_intentos",
  SIRE_CIERRES: "gco_sire_cierres",
  SIRE_AUDITORIA: "gco_sire_auditoria",

  // Módulo tributario (nuevo, aislado)
  DOCUMENTOS_TRIBUTARIOS: "gco_documentos_tributarios",
  REGISTROS_TRIBUTARIOS: "gco_registros_tributarios",

  // Core contable (Fase 17/19/22)
  IDEMPOTENCIA: "gco_operaciones_idempotentes",
  CORRELATIVOS_CUO: "gco_correlativos_cuo",
  CONFIG_CONTABLE: "gco_config_contable",
  PLE_ARCHIVOS: "gco_ple_archivos",
};
